import { Progress, type ProgressRootProps, Tooltip } from "@mantine/core"
import capitalize from "lodash/capitalize"
import { useTranslation } from "react-i18next"
import type { TUserSession } from "@/types"

export function SessionProgress({ data, ...props }: { data: TUserSession[] } & ProgressRootProps) {
  const { t } = useTranslation()

  const total = data.length
  const finished = data.filter((s) => s.finished).length
  const pending = data.filter((s) => s.state == "pending").length
  const in_progress = data.filter((s) => s.state == "in_progress" || s.state == "confirmed").length

  return (
    <Progress.Root size="lg" {...props} radius="sm">
      <Tooltip label={`${capitalize(t("finished"))}: ${finished}`}>
        <Progress.Section value={calcStat(total, finished)} color="green" />
      </Tooltip>
      <Tooltip label={`${capitalize(t("in progress"))}: ${in_progress}`}>
        <Progress.Section value={calcStat(total, in_progress)} color="blue" />
      </Tooltip>
      <Tooltip label={`${capitalize(t("pending"))}: ${pending}`}>
        <Progress.Section value={calcStat(total, pending)} color="gray" />
      </Tooltip>
    </Progress.Root>
  )
}
const calcStat = (total: number, value: number) => Math.round((value / total) * 100)
